export const formatDate = (strDate) => {
    return new Date(strDate).toLocaleDateString('es',
        {timeZone: "Europe/Madrid", year: 'numeric', month: '2-digit', day: '2-digit'}).split('/').join('-')
  }

export const getDayOfWeek = (strDate, language) => {
  return new Date(strDate).toLocaleString(
    language, {timeZone: "Europe/Madrid", weekday: 'long'}
  );
}